import { render } from "./MixinDemo.vue?vue&type=template&id=6372b14b"
import script from "./MixinDemo.vue?vue&type=script&lang=ts"
export * from "./MixinDemo.vue?vue&type=script&lang=ts"

import "./MixinDemo.vue?vue&type=style&index=0&id=6372b14b&lang=scss"
script.render = render

export default script